/* 右边全部 */

import React from 'react'
import NoSSR from 'react-no-ssr'

import Loading from 'Components/loading'

import CarList from './car-list'
import CarListSpider from './car-list-spider'
import Selected from './selected'
import Conditions from './conditions'

import { ISortProps, IConditionsProps } from './interface'

interface IProps {
  conditions: IConditionsProps[]
  sort: ISortProps[]
  foldProps: boolean
  spiderList?: any
}

export default function ConditionsList(props: IProps) {
  const { conditions, sort, foldProps, spiderList } = props
  return (
    <section>
      <Conditions conditions={conditions} foldprops={foldProps} />
      <Selected conditions={conditions} />
      {!spiderList ? (
        <NoSSR onSSR={<Loading />}>
          <CarList sort={sort} />
        </NoSSR>
      ) : (
        <CarListSpider spiderList={spiderList} />
      )}
    </section>
  )
}
